import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = [
  { q: "Is the agreement assumable by a new buyer?", a: "The agreement may be assumable by an eligible buyer. The transfer follows the process outlined in your contract." },
  { q: "Do the warranties and guarantees transfer?", a: "Yes. All warranties and guarantees are inherited by the new home owner." },
  { q: "Does solar increase my home's value or speed of sale?", a: "A predictable energy rate can be attractive to prospective buyers, but no increase in home value or speed of sale is guaranteed." },
  { q: "What happens with net metering when I move?", a: "The address will be grandfathered into the Net-Metering program as it was the day you were approved." },
];

const INSURANCE_FAQ = [
  { q: "Who insures the solar system?", a: "We maintain ownership and liabilities of the system, therefor we insure the system." },
  { q: "Is there a simple way to think about it?", a: "You do not personally insure the utility's power lines. Under the PPA, the system owner is responsible for its solar asset." },
  { q: "Do I need to notify my homeowner's insurance?", a: "No, you should not have to insure the system. However, we recommend checking with your insurance company. Be sure to tell them this is a PPA agreement and not ownership." },
];

export default function FAQSection() {
  return (
    <section className="py-20 md:py-28 bg-[#FDFBF7]" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="eyebrow">Moving · Selling · Insurance</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-4xl font-semibold text-[#0F382C]">
            What if I sell my home or move soon?
          </h2>
          <p className="mt-4 text-slate-600">
            Clear, qualified answers for the questions Virginia homeowners ask most.
          </p>
        </div>

        <div className="lg:col-span-8 space-y-8">
          <Accordion type="single" collapsible className="card-warm p-4 md:p-6" data-testid="faq-moving-accordion">
            {FAQ.map((f, i) => (
              <AccordionItem key={i} value={`m-${i}`} className="border-b border-[#E5E0D8] last:border-b-0">
                <AccordionTrigger className="font-serif-display text-lg text-[#0F382C] hover:no-underline text-left" data-testid={`faq-moving-q-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div>
            <h3 className="font-serif-display text-2xl text-[#0F382C] mb-4">What about insurance?</h3>
            <Accordion type="single" collapsible className="card-warm p-4 md:p-6" data-testid="faq-insurance-accordion">
              {INSURANCE_FAQ.map((f, i) => (
                <AccordionItem key={i} value={`i-${i}`} className="border-b border-[#E5E0D8] last:border-b-0">
                  <AccordionTrigger className="font-serif-display text-lg text-[#0F382C] hover:no-underline text-left" data-testid={`faq-insurance-q-${i}`}>
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
